<template>
  <div class="results-cards">
    <template v-if="loading">
      <skeleton-card v-for="cardNum in perPageTotal" :key="`skeleton-card-${cardNum}`" />
    </template>
    <template v-else>
      <!-- using flexbox order to set placement within cards -->
      <template v-if="!userAuthStore.features.ADS_FREE && showUnits">
        <card-grid-unit
          v-for="index in 4"
          v-show="index * markUnitInterval <= currentPageTotal"
          :key="`unit${index}`"
          :style="{ order: index * markUnitInterval }"
          :unit-slot-id="100"
          :google-unit-id="googleUnitId[index]"
        />
      </template>

      <!-- parent component to pass in cards -->
      <slot :card-order="cardOrder" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUserAuthStore } from '@/stores/user-auth'
import CardGridUnit from '@/components/units/card-grid-unit.vue'
import SkeletonCard from '@/components/loaders/skeleton-card.vue'
import type { EntityType } from '@/types/search-types'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    loading?: boolean
    perPageTotal: number
    currentPageTotal: number
    showUnits?: boolean
    entityType: EntityType
  }>(),
  {
    loading: false,
    showUnits: true,
  },
)

/** STATE **/
const userAuthStore = useUserAuthStore()

/** NON REACTIVE **/
const markUnitInterval = 5

/** COMPUTED **/
const googleUnitId = computed<Record<number, string>>(() => {
  if (props.entityType === 'article') {
    return {
      1: '7169530626',
      2: '9384630423',
      3: '7329791657',
      4: '6786387245',
    }
  }

  // workouts and all others
  return {
    1: '1334371830',
    2: '1334371830',
    3: '1334371830',
    4: '1334371830',
  }
})

/** METHODS **/
function cardOrder(index: number) {
  let indexBaseOne = index + 1

  // increment for each unit index
  ;[5, 10, 15, 20].forEach((unitIndex) => {
    if (indexBaseOne >= unitIndex) {
      indexBaseOne += 1
    }
  })

  return indexBaseOne
}
</script>
